module.exports = __webpack_public_path__ + "static/media/Profil.d15e36dd.png";